import React from 'react';
import { DialogContentText, Box } from '@mui/material';
import Modal from '../Modal/Modal';
import { AppButton } from '../UI';

const DialogDeleteCustom = ({
  open,
  handleClose,
  handleConfirm,
  title = "Confirmation de suppression",
  label,
  loading = false,
  confirmLabel,
}) => {
  const actions = (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
      <AppButton variant="secondary" onClick={handleClose} disabled={loading}>
        Annuler
      </AppButton>
      <AppButton
        variant="danger"
        onClick={handleConfirm}
        loading={loading}
      >
        {loading ? 'Suppression…' : (confirmLabel || 'Supprimer')}
      </AppButton>
    </Box>
  );

  return (
    <Modal
      open={open}
      onClose={!loading ? handleClose : undefined}
      title={title}
      actions={actions}
      maxWidth="sm"
    >
      <DialogContentText sx={{ py: 2, fontSize: '1rem', color: '#475569', fontFamily: "'Fira Sans', sans-serif" }}>
        {label}
      </DialogContentText>
    </Modal>
  );
};

export default DialogDeleteCustom;
